let navBarShown = true;
let enterTimeout: NodeJS.Timeout | undefined;

function handleMouseMove({ clientY }: { clientY: number }) {
  if (clientY < 15 || (navBarShown && clientY < 80)) {
    fullScreen(false);
  } else {
    fullScreen(true);
  }
}

function fullScreen(enabled: boolean) {
  if (enabled) {
    if (navBarShown) {
      navBarShown = false;
      document.body.classList.add('fullscreen');
    }
  } else {
    if (!navBarShown) {
      navBarShown = true;
      document.body.classList.remove('fullscreen');
    }
  }
}

/**
 * Should be called in componentDidMount of the page main component, to enable fullscreen mode (i.e. hiding navbar menu).
 */
export function enterFullscreen() {
  document.addEventListener('mousemove', handleMouseMove, false);
  enterTimeout = setTimeout(() => {
    fullScreen(true);
  }, 1200);
}

/**
 * Must be called in componentWillUnmount of the page main component to unhook the mousemove event handler.
 */
export function leaveFullscreen() {
  if (enterTimeout) {
    clearTimeout(enterTimeout);
    document.removeEventListener('mousemove', handleMouseMove, false);
    document.body.classList.remove('fullscreen');
  }
}
